module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props && _vm.activeTab) ? _c('div', {
    staticClass: "tab-services"
  }, [_c('div', {
    staticClass: "tab-services__container"
  }, _vm._l((_vm.props.block), function(block, i) {
    return _c('div', {
      staticClass: "tab-services__block"
    }, [_c('div', {
      staticClass: "tab-services__col-left"
    }, [_c('div', {
      staticClass: "tab-services__title",
      domProps: {
        "innerHTML": _vm._s(block.title)
      }
    }), _c('div', {
      staticClass: "tab-services__label-container"
    }, _vm._l((block.tabs), function(tab, j) {
      return _c('div', {
        staticClass: "tab-services__label",
        class: {
          'tab-services__label--active': _vm.activeTab[i].tab === j
        },
        domProps: {
          "innerHTML": _vm._s(tab.tab)
        },
        on: {
          "click": function($event) {
            return _vm.selectTab(i, j)
          }
        }
      })
    }), 0), _c('div', {
      staticClass: "tab-services__content-box"
    }, _vm._l((block.tabs), function(tab, k) {
      return _c('div', {
        staticClass: "tab-services__content",
        class: {
          'tab-services__content--active': _vm.activeTab[i].tab === k
        },
        domProps: {
          "innerHTML": _vm._s(tab.content)
        }
      })
    }), 0)]), _c('div', {
      staticClass: "tab-services__col-right"
    }, [_c('div', {
      directives: [{
        name: "waypoint",
        rawName: "v-waypoint",
        value: ({
          active: true,
          callback: _vm.onWaypointImage
        }),
        expression: "{ active: true, callback: onWaypointImage}"
      }],
      staticClass: "tab-services__waypoint"
    }), _c('div', {
      staticClass: "tab-services__image-mask"
    }, [_c('div', {
      staticClass: "tab-services__image",
      style: ({
        backgroundImage: 'url(' + block.image + ')'
      })
    })])]), _c('div', {
      staticClass: "tab-services__seperator"
    })])
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20167889","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/tab/tab-services/tab-services.pug
// module id = 546
// module chunks = 1